var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHome = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M5.071 22.166A2.57 2.57 0 0 1 2.5 19.595V9.328c0-.55.264-1.067.71-1.39l7.762-5.613a1.71 1.71 0 0 1 2.016.006l7.667 5.607c.441.323.702.837.702 1.384v10.273a2.57 2.57 0 0 1-2.571 2.571zm6.905-18.452L4.214 9.328v10.267c0 .473.384.857.857.857L8.5 20.45v-4.285c0-.947.768-1.714 1.714-1.714h3.429c.947 0 1.714.767 1.714 1.714v4.285h3.429a.857.857 0 0 0 .857-.856V9.322zm-1.762 12.452h3.429v4.286h-3.429z",
  clipRule: "evenodd"
})));
export default SvgHome;